import { useState } from "react";
import { useEffect } from "react";
import { motion } from "motion/react";
import { AnimatePresence } from "motion/react";

function Navbar() {
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const navLinks = [
      { label: "Accueil", href: "/" },
      { label: "Nos projets", href: "/projet" },
      { label: "Nous contacter", href: "/contact" },
      { label: "À propos", href: "/about" },
    ];

    useEffect(() => {
      const onScroll = () => setScrolled(window.scrollY > 20);
      window.addEventListener("scroll", onScroll);
      return () => window.removeEventListener("scroll", onScroll);
    }, []);
  
    return (
      <motion.nav
        initial={{ opacity: 0, y: -16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        className={`fixed top-0 left-0 right-0 z-50 px-4 md:px-0 transition-all duration-500 ${
          scrolled ? "bg-white/80 backdrop-blur-md shadow-sm" : "bg-transparent"
        }`}
      >
        <div className="mx-auto w-full max-w-6xl py-4 md:py-5">
          <div className="flex items-center justify-between md:hidden">
            <a href="/" className="text-sm font-semibold tracking-wide text-[#1a1a2e]">
              LMS
            </a>
            <button
              type="button"
              onClick={() => setMenuOpen((prev) => !prev)}
              aria-label="Ouvrir le menu"
              className="rounded-lg p-2 text-[#1a1a2e] hover:bg-[#1a1a2e]/5"
            >
              <span className="block h-0.5 w-6 bg-current mb-1.5" />
              <span className="block h-0.5 w-6 bg-current mb-1.5" />
              <span className="block h-0.5 w-6 bg-current" />
            </button>
          </div>

          <div className="hidden md:flex justify-center gap-10">
            {navLinks.map(({ label, href }) => (
              <motion.a
                key={label}
                href={href}
                className="relative text-sm font-medium text-[#1a1a2e] tracking-wide"
                whileHover="hover"
                animate="rest"
              >
                {label}
                <motion.span
                  className="absolute -bottom-0.5 left-0 h-[1.5px] bg-[#1a1a2e] block"
                  variants={{
                    rest: { width: "0%" },
                    hover: { width: "100%" },
                  }}
                  transition={{ duration: 0.25, ease: "easeOut" }}
                />
              </motion.a>
            ))}
          </div>

          <AnimatePresence>
            {menuOpen && (
              <motion.div
                initial={{ opacity: 0, y: -8, scale: 0.98 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                exit={{ opacity: 0, y: -8, scale: 0.98 }}
                transition={{ duration: 0.22, ease: "easeOut" }}
                className="mt-3 rounded-2xl border border-[#1a1a2e]/10 bg-white/95 p-3 shadow-md md:hidden"
              >
                <div className="flex flex-col">
                  {navLinks.map(({ label, href }) => (
                    <a
                      key={label}
                      href={href}
                      onClick={() => setMenuOpen(false)}
                      className="rounded-lg px-3 py-2 text-sm font-medium text-[#1a1a2e] hover:bg-[#1a1a2e]/5"
                    >
                      {label}
                    </a>
                  ))}
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </motion.nav>
    );
  }

export default Navbar;